export default {
    methods: {
        getRoundedPrice(value) {
            let valueRounded = value;
            if (
                !isNaN(valueRounded) && valueRounded !== null && value.toFixed &&
                this.$configuration.priceConfig.isCustomLengthAfterDecimalPoint
            ) {
                valueRounded = value.toFixed(this.$configuration.priceConfig.lengthAfterDecimalPoint);
            }
            return valueRounded;
        },
    },
};
